import {
  Component,
  EventEmitter,
  HostListener,
  Input,
  Output,
} from '@angular/core';
import { ModalService } from 'ng-devui';
import { NzMessageService } from 'ng-zorro-antd/message';
import {
  AlertDialogComponent,
  AlertDialogType,
} from 'src/app/modules/shared/components/alert-dialog/alert-dialog.component';
import {
  TableColumnConfig,
  TableColumnOption,
  TableColumnType,
  TableConfig,
} from 'src/app/modules/shared/components/table-pro/table.config';
import { ArchiveCatalog } from 'src/app/modules/shared/models/archive/archive-catalog.model';
import { ArchiveFileStatus } from 'src/app/modules/shared/models/archive/archive-file-status.enum';
import { ArchiveFileSyncRuleType } from 'src/app/modules/shared/models/archive/archive-file-sync-rule-type.enum';
import { ArchiveFile } from 'src/app/modules/shared/models/archive/archive-file.model';
import {
  ArchiveKeepPeriodTypeMap,
  ArchiveKeepPeriodTypeOptions,
} from 'src/app/modules/shared/models/archive/archive-keep-period-type.enum';
import {
  ArchiveStatus,
  ArchiveStatusMap,
  ArchiveStatusOptions,
} from 'src/app/modules/shared/models/archive/archive-status.enum';
import { ArchiveVolumeListRequest } from 'src/app/modules/shared/models/archive/archive-volume-list-request.model';
import { ArchiveVolume } from 'src/app/modules/shared/models/archive/archive-volume.model';
import { FileType } from 'src/app/modules/shared/models/form/file-type.enum';
import { ProjectSection } from 'src/app/modules/shared/models/project/project-section.model';
import { EventService } from 'src/app/modules/shared/providers/event.service';
import * as moment from 'moment';
import 'moment/locale/zh-cn';
import { GlobalService } from 'src/app/modules/shared/providers/global.service';
import { FileResponse } from 'src/app/modules/shared/providers/request/file-response.model';
import { OrderType } from 'src/app/modules/shared/providers/request/order-type.enum';
import { ArchiveCatalogService } from 'src/app/modules/shared/services/archive-catalog.service';
import { ArchiveVolumeService } from 'src/app/modules/shared/services/archive-volume.service';
import { CommonService } from 'src/app/modules/shared/services/common.service';
import { ProjectSectionService } from 'src/app/modules/shared/services/project-section.service';
import { environment } from 'src/environments/environment';
import { DialogArchiveUploadFillComponent } from '../../../dialogs/projects-profiles/dialog-archive-upload-fill/dialog-archive-upload-fill.component';
import { DialogProjectsProfilesVolumnAddComponent } from '../../../dialogs/projects-profiles/dialog-projects-profiles-volumn-add/dialog-projects-profiles-volumn-add.component';
import { DialogProjectsProfilesVolumnEditComponent } from '../../../dialogs/projects-profiles/dialog-projects-profiles-volumn-edit/dialog-projects-profiles-volumn-edit.component';
import { DialogProjectsProfilesVolumnSyncComponent } from '../../../dialogs/projects-profiles/dialog-projects-profiles-volumn-sync/dialog-projects-profiles-volumn-sync.component';
import { DialogProjectsProfilesVolumnTitleRuleWbsComponent } from '../../../dialogs/projects-profiles/dialog-projects-profiles-volumn-title-rule-wbs/dialog-projects-profiles-volumn-title-rule-wbs.component';
import { DialogProjectsProfilesVolumnTitleRuleNonWbsComponent } from '../../../dialogs/projects-profiles/dialog-projects-profiles-volumn-title-rule/dialog-projects-profiles-volumn-title-rule.component';

@Component({
  selector: 'projects-profiles-volume',
  templateUrl: './projects-profiles-volume.component.html',
  styleUrls: ['./projects-profiles-volume.component.scss'],
})
export class ProjectsProfilesVolumeComponent {
  volumeConfig?: TableConfig = new TableConfig();

  volumeConfigTotalWidth = 0;

  volumeCheckAll = false;

  recordList: ArchiveVolume[] = [];

  volumeRecordList: ArchiveVolume[] = [];

  volumeSearchRequest = new ArchiveVolumeListRequest();

  volumeSortOrderOpts: TableColumnOption[] = [];

  ArchiveKeepPeriodTypeMap = ArchiveKeepPeriodTypeMap;

  ArchiveStatusMap = ArchiveStatusMap;

  ArchiveStatus = ArchiveStatus;

  checkcount = 0;

  checkRemoveableCount = 0;

  // @HostListener('window:visibilitychange')
  // handleVisibilityChange() {
  //   this.getVolumeList();
  // }

  @Input()
  regular = true;

  @Input()
  set readonly(value: boolean) {
    this._readonly = value;
    this.initConfig();
  }

  get readonly() {
    return this._readonly;
  }

  _readonly = false;

  projectSections: ProjectSection[] = [];

  title = '';

  @Input()
  set root(value: ArchiveCatalog) {
    this._root = value;
    if (!!this._root.id) {
      this.archiveCatalogService
        .findAll({
          sectionType: this.root.sectionType,
          projectId: this.globalService.projectId,
        })
        .subscribe((res) => {
          this.title = this.getTitle(res, this.root.id!);
          document.title = this.root.name!;
        });
    }
  }

  private getTitle(catalogs: ArchiveCatalog[], id: number): string {
    const catalog = catalogs.find((catalog) => catalog.id === id);
    if (!catalog) {
      return '';
    }
    const parentTitle = this.getTitle(catalogs, catalog.parentId!);
    if (!!parentTitle) {
      return `${parentTitle} \\ ${catalog.name}`;
    } else {
      return catalog.name!;
    }
  }

  get root(): ArchiveCatalog {
    return this._root;
  }
  _root: ArchiveCatalog = new ArchiveCatalog();

  @Output()
  onVolumeSelectedChange = new EventEmitter<ArchiveVolume[]>();

  @Output()
  onVolumeChange = new EventEmitter<ArchiveVolume[]>();

  @Output()
  onFileSynced = new EventEmitter<null>();

  pager = this.globalService.recoverPager();

  get withToken() {
    return '?token=' + this.globalService.token;
  }

  constructor(
    private modalService: ModalService,
    private archiveCatalogService: ArchiveCatalogService,
    private archiveVolumeService: ArchiveVolumeService,
    private globalService: GlobalService,
    private commonService: CommonService,
    private nzMessage: NzMessageService,
    private projectSectionService: ProjectSectionService,
    private events: EventService,
  ) {}

  ngOnInit(): void {
    this.projectSectionService
      .findAll({
        projectId: this.globalService.projectId,
      })
      .subscribe((sections) => {
        this.projectSections = sections;
      });

    this.events.on('volumeListUpdate', this.updateVolumeInfo);
  }

  updateVolumeInfo = () => {
    this.archiveVolumeService
      .findAll(this.volumeSearchRequest)
      .subscribe((data: ArchiveVolume[]) => {
        const volumeMap: { [key: number]: ArchiveVolume } = {};
        for (const volume of data) {
          // 不要删很重要
          volume.sortOrderLabel = (volume.sortOrder ?? '')
            .toString()
            .padStart(3, '0');
          volumeMap[volume.id!] = volume;
        }
        for (const volume of this.recordList) {
          for (const key in volume) {
            if (key === 'selected') continue;
            if (volumeMap[volume.id!][key] !== volume[key]) {
              volume[key] = volumeMap[volume.id!][key];
            }
          }
        }
        this.handlePageRecord();
      });
  };

  private initConfig() {
    const volumeColumns: TableColumnConfig[] = [
      {
        name: ' ',
        key: 'action',
        type: TableColumnType.actions,
        width: 40,
      },
      {
        name: '卷序',
        key: 'sortOrder',
        type: TableColumnType.text,
        width: 50,
        sortable: true,
        sortKey: 'sortOrderOrder',
        sortDefault: OrderType.ASC,
        sortOrder: 1,
      },
      {
        name: '档号',
        key: 'code',
        type: TableColumnType.text,
        width: 100,
        queryable: true,
        queryKey: 'code',
      },
      {
        name: '案卷题名',
        key: 'title',
        type: TableColumnType.text,
        width: 100,
        queryable: true,
        queryKey: 'title',
        sortable: true,
        sortKey: 'titleOrder',
        sortDefault: OrderType.ASC,
      },
      {
        name: '页数',
        key: 'filePageCount',
        type: TableColumnType.text,
        width: 60,
        sortable: true,
        sortKey: 'filePageCountOrder',
      },
      {
        name: '起止时间',
        key: 'startTime',
        type: TableColumnType.date,
        width: 80,
      },
      {
        name: '保管期限',
        key: 'keepPeriodType',
        type: TableColumnType.options,
        options: ArchiveKeepPeriodTypeOptions,
        width: 60,
        queryable: true,
        queryKey: 'keepPeriodType',
      },
      {
        name: '备注',
        key: 'comment',
        type: TableColumnType.text,
        width: 100,
        queryable: true,
        queryKey: 'comment',
      },
      {
        name: '状态',
        key: 'status',
        type: TableColumnType.options,
        options: ArchiveStatusOptions,
        width: 60,
      },
    ];

    if (!this.readonly) {
      volumeColumns.push({
        name: '操作',
        key: 'action',
        type: TableColumnType.actions,
        width: 90,
      });
    }

    this.volumeConfig = {
      columns: volumeColumns,
      hideQuery: false,
    };

    this.volumeConfigTotalWidth = volumeColumns.reduce(
      (acc, cur) => acc + cur.width,
      0,
    );
    this.resetVolumeSearch();
  }

  searchVolumeClick(data: any) {
    this.prepareVolumeSearch(data);
    this.getVolumeList();
  }

  private prepareVolumeSearch(data: any) {
    this.volumeSearchRequest = new ArchiveVolumeListRequest();
    this.volumeSearchRequest.projectId = this.globalService.projectId;
    this.volumeSearchRequest.catalogId = this.root.id;
    this.volumeSearchRequest.orderedSortFields = [
      'sortOrderOrder',
      'titleOrder',
      'filePageCountOrder',
    ];
    Object.assign(this.volumeSearchRequest, data);
  }

  resetVolumeSearch() {
    this.volumeSearchRequest = new ArchiveVolumeListRequest();
    this.volumeSearchRequest.catalogId = this.root.id;
    this.volumeSearchRequest.projectId = this.globalService.projectId;
    this.volumeSearchRequest.orderedSortFields = [
      'sortOrderOrder',
      'titleOrder',
      'filePageCountOrder',
    ];
    this.volumeSearchRequest.sortOrderOrder = OrderType.ASC;
    this.volumeSearchRequest.titleOrder = OrderType.DESC;
    this.getVolumeList();
  }

  private getVolumeList() {
    this.archiveVolumeService
      .findAll(this.volumeSearchRequest)
      .subscribe((data: ArchiveVolume[]) => {
        const sortOrderOpts: TableColumnOption[] = [];
        for (const record of data) {
          record.selected = true;
          record.sortOrderLabel = (record.sortOrder ?? '')
            .toString()
            .padStart(3, '0');
          sortOrderOpts.push({
            label: record.sortOrderLabel!,
            value: record.sortOrder!,
          });
          record.sortOrderTarget = record.sortOrder;
        }
        this.recordList = data;
        this.volumeSortOrderOpts = sortOrderOpts;
        this.root.volumeCount = this.recordList.length;
        this.onVolumeChange.emit(this.recordList);
        this.onFileSynced.emit();
        this.onVolumeCheck();

        this.pager.pageIndex = 1;
        this.pager.total = this.recordList.length;
        this.handlePageRecord();
      });
  }

  onVolumeCheckAllChange() {
    let checkcount = 0;
    let checkRemoveableCount = 0;
    for (const volume of this.recordList ?? []) {
      volume.selected = this.volumeCheckAll;
      if (volume.selected) {
        checkcount++;
        if (volume.status === ArchiveStatus.UNLOCK) {
          checkRemoveableCount++;
        }
      }
    }
    this.checkRemoveableCount = checkRemoveableCount;
    this.checkcount = checkcount;
    this.onVolumeSelectedChange.emit(
      this.recordList
        .filter((volume) => !!volume.selected)
        .map((volume) => volume),
    );
    this.handlePageRecord();
  }

  onVolumeCheck() {
    let checkall = true;
    let checkcount = 0;
    let checkRemoveableCount = 0;
    for (const volume of this.recordList ?? []) {
      if (!volume.selected) {
        checkall = false;
      }
      if (volume.selected) {
        checkcount++;
        if (volume.status === ArchiveStatus.UNLOCK) {
          checkRemoveableCount++;
        }
      }
    }
    this.checkcount = checkcount;
    this.checkRemoveableCount = checkRemoveableCount;
    this.volumeCheckAll = checkall;
    this.onVolumeSelectedChange.emit(
      this.recordList
        .filter((volume) => !!volume.selected)
        .map((volume) => volume),
    );
    this.handlePageRecord();
  }

  sync() {
    const results = this.modalService.open({
      component: DialogProjectsProfilesVolumnSyncComponent,
      onClose: () => {},
      data: {
        data: this.root,
        onCancel: () => {
          results.modalInstance.hide();
        },
        onConfirm: () => {
          results.modalInstance.hide();
          window.location.reload();
          // this.onVolumeSelectedChange.emit(
          //   this.volumeRecordList
          //     .filter((volume) => volume.selected)
          //     .map((volume) => volume)
          // );
          // this.onFileSynced.emit();
        },
      },
    });
  }

  fileNameRule() {
    // TODO
    if (!!this.root.sectionItemId || !!this.root.dwTypeCode) {
      const results = this.modalService.open({
        component: DialogProjectsProfilesVolumnTitleRuleWbsComponent,
        onClose: () => {},
        data: {
          data: this.root,
          onCancel: () => {
            results.modalInstance.hide();
          },
          onConfirm: () => {
            results.modalInstance.hide();
            this.getVolumeList();
          },
        },
      });
    } else {
      const results = this.modalService.open({
        component: DialogProjectsProfilesVolumnTitleRuleNonWbsComponent,
        onClose: () => {},
        data: {
          data: this.root,
          onCancel: () => {
            results.modalInstance.hide();
          },
          onConfirm: () => {
            results.modalInstance.hide();
            this.getVolumeList();
          },
        },
      });
    }
  }

  volumeAdd() {
    console.log(this.root);
    const results = this.modalService.open({
      component: DialogProjectsProfilesVolumnAddComponent,
      onClose: () => {},
      data: {
        data: this.root,
        onCancel: () => {
          results.modalInstance.hide();
        },
        onConfirm: (saveOnly?: boolean) => {
          if (!saveOnly) {
            results.modalInstance.hide();
          }
          this.getVolumeList();
        },
      },
    });
  }

  volumeEdit(row: number) {
    if (this.recordList[row].status !== ArchiveStatus.UNLOCK) {
      return;
    }
    const volume = this.recordList[row];
    for (const rule of this.root.fileSyncRules ?? []) {
      if (
        rule.type === ArchiveFileSyncRuleType.MATERIAL &&
        rule.checked &&
        !!rule.content
      ) {
        volume.isMaterial = true;
      }
    }
    const results = this.modalService.open({
      component: DialogProjectsProfilesVolumnEditComponent,
      onClose: () => {},
      data: {
        data: volume,
        onCancel: () => {
          results.modalInstance.hide();
        },
        onConfirm: () => {
          results.modalInstance.hide();
          this.getVolumeList();
        },
      },
    });
  }

  volumeRemove(row: number) {
    if (this.recordList[row].status !== ArchiveStatus.UNLOCK) {
      return;
    }
    const results = this.modalService.open({
      backdropCloseable: false,
      component: AlertDialogComponent,
      onClose: () => {},
      data: {
        title: '删除选中',
        content: '确认删除该卷？',
        cancelBtnText: '取消',
        confirmBtnText: '确认',
        contentStyle: 'danger',
        type: AlertDialogType.prompt,
        onCancel: () => {
          console.log('cancel');
          results.modalInstance.hide();
        },
        onConfirm: () => {
          results.modalInstance.hide();
          this.removeVolume(this.recordList[row].id!);
        },
      },
    });
  }

  volumeLock(row: number) {
    const record = this.recordList[row];
    if (record.status === ArchiveStatus.LOCK) {
      return;
    }
    this.archiveVolumeService.lock(record.id!).subscribe((workFlowKey) => {
      if (workFlowKey) {
        this.sign(workFlowKey);
        this.getVolumeList();
      }
    });
  }

  sign(workFlowKey: string) {
    const query = window.location.href.split('?')[1] ?? '';
    const params = new URLSearchParams(query);
    if (location.href.indexOf('#/open/') > -1) {
      this.openInTab(
        `#/open/custom-form/sign/${workFlowKey!}?token=${params.get('token')}`,
      );
    } else {
      this.openInTab(`#/custom-form/sign/${workFlowKey!}`);
    }
  }

  private openInTab(url: string) {
    const target = window.open(url, '_blank');
    setTimeout(() => {
      target?.postMessage({
        type: 'redir',
        data: window.location.href,
      });
    }, 1000);
    // target?.postMessage('redir', window.location.href);
  }

  volumeUnlock(row: number) {
    if (this.root.status !== ArchiveStatus.UNLOCK) {
      this.nzMessage.error('档案目录已锁档，无法解锁，请先解档档案目录。');
      return;
    }
    const record = this.recordList[row];
    if (record.status !== ArchiveStatus.LOCK) {
      return;
    }
    this.archiveVolumeService.unlock(record.id!).subscribe((res) => {
      if (res) {
        this.nzMessage.success('解锁成功');
        this.getVolumeList();
      }
    });
  }

  volumePrint(printedFileId?: string) {
    if (!printedFileId) {
      this.nzMessage.warning('打印文件尚未生成');
      return;
    }
    window.open(
      environment.fileHost + printedFileId + this.withToken,
      '_blank',
    );
  }

  volumeDownload(row: number) {
    const record = this.recordList[row];
    if (record.status !== ArchiveStatus.LOCK) {
      this.nzMessage.warning('请先锁定卷后再下载');
      return;
    }
    const fileName = `${record.title}.zip`;
    this.commonService
      .download(record.volumeZipFileId!, fileName)
      .subscribe((blob) => {
        const url = window.URL.createObjectURL(blob);
        const downloadLink = document.createElement('a');
        downloadLink.href = url;
        downloadLink.download = fileName;
        document.body.appendChild(downloadLink);
        downloadLink.click();
        document.body.removeChild(downloadLink);
        window.URL.revokeObjectURL(url);
      });
  }

  private removeVolume(id: number) {
    this.archiveVolumeService.remove(id).subscribe(() => {
      this.nzMessage.success('删除成功');
      this.getVolumeList();
    });
  }

  clearVolume() {
    const results = this.modalService.open({
      backdropCloseable: false,
      component: AlertDialogComponent,
      onClose: () => {},
      data: {
        title: '确认『清空文件』',
        content: '将文件库中的所有文件移出？',
        cancelBtnText: '取消',
        confirmBtnText: '确认',
        contentStyle: 'danger',
        type: AlertDialogType.confirm,
        onCancel: () => {
          results.modalInstance.hide();
        },
        onConfirm: () => {
          results.modalInstance.hide();
          this.clearVolumeFiles();
        },
      },
    });
  }

  upload(event: any) {
    const files = event.target['files'];
    console.log(files);
    this.commonService
      .uploadFileWithoutProgress(files[0])
      .subscribe((url: FileResponse) => {
        const archiveFile = new ArchiveFile();
        archiveFile.fileId = url.fileId;
        archiveFile.projectId = this.globalService.projectId;
        archiveFile.catalogId = this.root.id;
        archiveFile.fileType = FileType.PDF;
        archiveFile.fileName = files[0].name.split('.')[0];
        archiveFile.fileStatus = ArchiveFileStatus.OK;

        event.target['value'] = '';
        const results = this.modalService.open({
          component: DialogArchiveUploadFillComponent,
          onClose: () => {},
          data: {
            data: archiveFile,
            onCancel: () => {
              results.modalInstance.hide();
            },
            onConfirm: () => {
              results.modalInstance.hide();
              this.getVolumeList();
            },
          },
        });
      });
  }

  private clearVolumeFiles() {
    this.archiveCatalogService.clearFile(this.root.id!).subscribe((res) => {
      if (res) {
        window.location.reload();
      }
    });
  }

  onVolumeSortOrderChange(record: ArchiveVolume) {
    const sourceId = record.id;
    const targetId = this.recordList.find(
      (item) => item.sortOrder === record.sortOrderTarget,
    )?.id;
    this.archiveVolumeService
      .move({
        sourceVolumeId: sourceId!,
        targetVolumeId: targetId!,
      })
      .subscribe(() => {
        // this.nzMessage.success('更新成功');
        this.getVolumeList();
      });
  }

  pageIndexChange(index: number) {
    this.pager.pageIndex = index;
    this.handlePageRecord();
  }

  pageSizeChange(size: number) {
    this.pager.pageSize = size;
    this.pager.pageIndex = 1;
    this.handlePageRecord();
  }

  private handlePageRecord() {
    if (this.recordList.length < this.pager.pageSize) {
      this.volumeRecordList = this.recordList;
    } else {
      this.volumeRecordList = this.recordList.slice(
        (this.pager.pageIndex - 1) * this.pager.pageSize,
        this.pager.pageIndex * this.pager.pageSize,
      );
    }
  }

  batchDownload() {
    if (this.checkcount === 0) {
      return;
    }
    const ids = this.recordList
      .filter((item) => item.selected)
      .map((item) => item.id!);
    console.log(this.root);
    const fileName =
      this.root.name! +
      '-' +
      moment(new Date().toISOString())
        .locale('zh_cn')
        .format('yyyy-MM-DD HH:mm:ss') +
      '.zip';
    this.archiveVolumeService
      .downloadFileByIds(fileName, ids)
      .subscribe((res) => {
        const blob = new Blob([res], {
          type: 'application/zip',
        });
        const url = window.URL.createObjectURL(blob);
        const downloadLink = document.createElement('a');
        downloadLink.href = url;
        downloadLink.download = fileName;
        document.body.appendChild(downloadLink);
        downloadLink.click();
      });
  }

  batchRemove() {
    if (this.checkRemoveableCount === 0) {
      return;
    }
    const results = this.modalService.open({
      backdropCloseable: false,
      component: AlertDialogComponent,
      onClose: () => {},
      data: {
        title: '删除选中',
        content: '确认删除选中卷？',
        cancelBtnText: '取消',
        confirmBtnText: '确认',
        contentStyle: 'danger',
        type: AlertDialogType.prompt,
        onCancel: () => {
          results.modalInstance.hide();
        },
        onConfirm: () => {
          results.modalInstance.hide();
          const ids = this.recordList
            .filter(
              (item) => item.selected && item.status === ArchiveStatus.UNLOCK,
            )
            .map((item) => item.id!);
          this.archiveVolumeService.removeBatch(ids).subscribe(() => {
            this.nzMessage.success('删除成功');
            this.getVolumeList();
          });
        },
      },
    });
  }
}
